import PropTypes from 'prop-types';
import NumberFlow from '@number-flow/react';
import { useEffect, useState } from 'react';
import classes from './stats.module.css';

const countDigits = (number = 0) => Math.abs(number).toString().length;

const Stats = (props) => {
  const {
    value = 124,
    title,
    subtitle,
  } = props;

  const start = ''.padStart(countDigits(value), '9');

  const [v, setV] = useState(start);

  useEffect(() => {
    setV(value);
  }, [value]);

  return (
    <div className={classes.stats}>
      <div className={classes.body}>
        {title && <div className={classes.title}>{title}</div>}
        {subtitle && <div className={classes.subtitle}>{subtitle}</div>}
      </div>
      <div className={classes.value}>
        <NumberFlow value={v} transformTiming={{
          duration: 1000,
          easing: 'linear(0, 0.0033 0.8%, 0.0263 2.39%, 0.0896 4.77%, 0.4676 15.12%, 0.5688, 0.6553, 0.7274, 0.7862, 0.8336 31.04%, 0.8793, 0.9132 38.99%, 0.9421 43.77%, 0.9642 49.34%, 0.9796 55.71%, 0.9893 62.87%, 0.9952 71.62%, 0.9983 82.76%, 0.9996 99.47%)',
        }} />
      </div>
    </div>
  );
};

Stats.propTypes = {
  value: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
};

export default Stats;
